import axios from 'axios';
import router from '@/routes/router';
const isProd = process.env.NODE_ENV === 'production';

const apiUrl = process.env.VUE_APP_URL_BASE;

let header = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response) {
    if (error.response.status === 401 || error.response.status === 400 || error.response.status === 404 || error.response.status === 500) {
      localStorage.clear();
      router.push('/').catch();
    }
  }
  return Promise.reject(error);
});

function jsonToURLEncoded(jsonString) {
  return Object.keys(jsonString)
    .map(key => (`${encodeURIComponent(key)}=${encodeURIComponent(jsonString[key])}`))
    .join('&');
}

const get = async function (endpoint, params = null, thereIsToken = false) {
  return new Promise(async (resolve) => {
    if (thereIsToken) {
      const token = localStorage.getItem('oanda-token-admin');
      header = {Authorization: 'Bearer '.concat(token)};
    }
    if (params) {
      resolve(axios.get(`${apiUrl + endpoint}/${params}`, {headers: header}));
    } else {
      resolve(axios.get(apiUrl + endpoint, {headers: header}));
    }
  });
};

const post = async function (endpoint, params = null, thereIsToken = false) {
  if (thereIsToken) {
    const token = localStorage.getItem('oanda-token-admin');
    header = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
  }
  if (params) {
    return axios.post(apiUrl + endpoint, params, {headers: header});
  } else {
    return axios.post(apiUrl + endpoint, {}, {headers: header});
  }
};

const put = function (endpoint, params = null, thereIsToken = false) {
  return new Promise(async (resolve) => {
    if (thereIsToken) {
      const token = localStorage.getItem('oanda-token-admin');
      header = {Authorization: 'Bearer '.concat(token)};
    }
    axios
      .put(apiUrl + endpoint, params, {headers: header})
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {

      });
  });
};

export {post, get, put};
